module.exports = __webpack_public_path__ + "static/media/2000px-Applications-internet.svg.cd7ac259.png";